export default __webpack_public_path__ + "static/media/page_crypted_help2.7205d6ea.png";